import { withTranslation } from "react-i18next";
import SupplierInfo from './SupplierInfo';

export default withTranslation()(SupplierInfo);